const MissionSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
          Our Mission
        </h2>
        
        {/* Quote Block - Ready for your content */}
        <blockquote className="relative">
          <div className="text-xl md:text-2xl text-gray-700 italic leading-relaxed mb-4">
            <span className="text-3xl text-red-600 leading-none align-top">"</span>
            <p className="inline">
              {/* Your mission quote will go here */}
              We are partners with our clients.  The feedback we obtain allows us to constantly improve our offerings.  Together we are able to run our businesses better, with less risk and more profit. 
            </p>
            <span className="text-3xl text-red-600 leading-none align-top">"</span>
          </div>
          <footer className="text-gray-600 font-medium mt-6">
            {/* President's name and title */}
            <cite className="not-italic">— Thomas Morgan, Founder & President</cite>
          </footer>
        </blockquote>
      </div>
    </section>
  );
};

export default MissionSection;
